import { ENV } from 'app/core/helpers/constants';

export function getEnvironment(){
  const url = window.location.href;
  if(url.includes('flexben-dev.azurewebsites.net')) {
    return ENV.DEV;
  }
  if (url.includes('flexben-test.azurewebsites.net')) {
    return ENV.TEST;
  }
  if (url.includes('flexben-demo.mybenefits.ro')) {
    return ENV.DEMO;
  }
  if (url.includes('flexben.mybenefits.ro')) {
    return ENV.PROD;
  }
  if (url.includes('localhost')) {
    return ENV.LOCAL;
  }
}
